import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import {
  dateDifferenceInDaysFromToday,
  USDT
} from '../../../helpers/helperFunctions';
import { CaptionText, H2, H3, H4, P2, P3 } from '../../../styles/FontStyles';
import { Box, CheckIconBox, Flexed } from '../../../styles/GlobalComponents';
import { color, colors } from '../../../styles/GlobalStyles';
import { Icon, IconPackagesCheck } from '../../../styles/Icons';
import { FlexBetween, FlexCenter } from '../../../styles/stylesStyled';
import { Button } from '../Button/Button';
import { PromotionBanner } from './VirtualOfficeSubscription.styled';
import { useAppSelector } from '../../../app/hooks';

interface VirtualOfficeCard {
  plan: any;
  setSelected: Dispatch<SetStateAction<any>>;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  setStep: Dispatch<SetStateAction<number>>;
}

export const VirtualOfficeCard = ({
  plan,
  setIsOpen,
  setSelected,
  setStep
}: // setSelectedHub
VirtualOfficeCard) => {
  const { t } = useTranslation('settings');

  return (
    <Box style={{ display: 'flex' }} gray p='20px' m='0' mSM='0'>
      <Flexed column between style={{ flexGrow: 1 }}>
        <div>
          <P3 center bold mb='5'>
            {plan.access} - Year {plan.id === 2 && '(2 + 1 free)'}{' '}
            {(plan.id === 6 || plan.id === 7) && 'offer'}
          </P3>

          <H2 center bold mb='5' mt='5'>
            {plan.price} {USDT}
          </H2>

          {plan.id === 2 ? (
            <Flexed center column mb='15'>
              <PromotionBanner>
                <CaptionText semiBold caps color={color.colors.neutral0}>
                  PROMOTION
                </CaptionText>
              </PromotionBanner>
            </Flexed>
          ) : plan.id === 6 || plan.id === 7 ? (
            <Flexed center column mb='15'>
              <PromotionBanner>
                <CaptionText semiBold caps color={color.colors.neutral0}>
                  {plan.id === 6 ? 'BUILDER OFFER' : 'ACCESS OFFER'}
                </CaptionText>
              </PromotionBanner>
            </Flexed>
          ) : (
            <Flexed center column mb='45'></Flexed>
          )}

          {plan.benefits.map((benefit: any, i: any) => (
            <div style={{ marginBottom: 10, marginTop: 15 }} key={i}>
              <FlexCenter>
                <CheckIconBox
                  style={{ flex: 'none' }}
                  background={benefit.text === ''}>
                  <Icon>
                    <IconPackagesCheck />
                  </Icon>
                </CheckIconBox>
                <P3>{benefit.text}</P3>
              </FlexCenter>
            </div>
          ))}
        </div>
        <div>
          <H4 bold mt='10' color={colors.neutral900} center>
            {plan.save &&
              `${t('virtual_office.plans.save')} ${plan.save || '00'}%`}
          </H4>
          {(plan?.id === 6 || plan?.id === 7) && (
            <H4 bold mt='10' color={colors.neutral900} center>
              {plan.daysRemaining} days left
            </H4>
          )}

          <Button
            w='100%'
            mt='15'
            onClick={() => {
              setSelected(plan);
              setIsOpen(true);
              setStep(1);
            }}>
            {plan.id === 6 || plan.id === 7
              ? 'Get the offer'
              : `Get ${plan.access} ${plan.access === 3 ? 'years' : 'year'}`}
          </Button>
        </div>
      </Flexed>
    </Box>
  );
};
